import componentsList from './components';
export * from './hooks';
export * from './components/index';
export * from './utils/types';

// global register
const vue3BaiduMapGl = {
    install: (app, options) => {
        const { ak, apiUrl, plugins: p, pluginsSourceLink: psl } = options || {};
        const appProp = app.config.globalProperties;
        for (const component of componentsList) {
            const name = component.name;
            app.component(name, component);
        }
        ak && (appProp.$baiduMapAk = ak);
        apiUrl && (appProp.$baiduMapApiUrl = apiUrl);
        p && (appProp.$baiduMapPlugins = p);
        psl && (appProp.$baiduMapPluginsSourceLink = psl);
    },
    version: '2.4.0'
};
// for umd
const install = vue3BaiduMapGl.install;
const version = vue3BaiduMapGl.version;

export { vue3BaiduMapGl as default, install, version };
